(()=>{
 'use strict';
 const instances=new WeakMap();
 function init(root){
  if(root.dataset.ready)return;
  const viewport=root.querySelector('.hx-announcement__viewport');
  const group=root.querySelector('.hx-announcement__group');
  const button=root.querySelector('[data-hx-pause]');
  if(!viewport||!group||!button)return;
  const media=matchMedia('(prefers-reduced-motion: reduce)');
  function size(){root.style.setProperty('--hx-announcement-width',viewport.clientWidth+'px');root.style.setProperty('--hx-announcement-duration',Math.max(20,group.getBoundingClientRect().width/38)+'s');}
  function motion(){button.hidden=media.matches;viewport.tabIndex=media.matches?0:-1;size();}
  button.addEventListener('click',()=>{
   const paused=!root.hasAttribute('data-paused');
   root.toggleAttribute('data-paused',paused);
   button.setAttribute('aria-label',paused?'Resume announcements':'Pause announcements');
   button.setAttribute('aria-pressed',String(paused));
   button.querySelector('[data-pause-icon]').hidden=paused;
   button.querySelector('[data-play-icon]').hidden=!paused;
  });
  const observer=new ResizeObserver(size);observer.observe(viewport);observer.observe(group);
  media.addEventListener('change',motion);
  document.fonts?.ready.then(()=>{if(root.isConnected)size()});
  instances.set(root,{observer,media,motion});
  motion();root.dataset.ready='true';
 }
 function scan(){document.querySelectorAll('[data-hx-announcement]').forEach(init)}
 scan();
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('shopify:section:unload',event=>{
  event.target.querySelectorAll('[data-hx-announcement]').forEach(root=>{
   const state=instances.get(root);if(!state)return;
   state.observer.disconnect();state.media.removeEventListener('change',state.motion);instances.delete(root);
  });
 });
 document.addEventListener('shopify:block:select',event=>{
  const item=[...document.querySelectorAll('.hx-announcement__group:not([data-copy]) [data-announcement-id]')].find(el=>el.dataset.announcementId===event.detail.blockId);
  if(!item)return;
  const root=item.closest('[data-hx-announcement]');root.setAttribute('data-editor-selected','');
  item.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
 });
 document.addEventListener('shopify:block:deselect',()=>{
  document.querySelectorAll('[data-hx-announcement][data-editor-selected]').forEach(root=>{
   root.removeAttribute('data-editor-selected');root.querySelector('.hx-announcement__viewport').scrollLeft=0;
  });
 });
})();
